export default __webpack_public_path__ + "static/media/jacksonville.a6fbd50c.jpg";